module.exports = "/static/assets/3ec293692bbf3e8eb82f1e191c782ca4.png";